module.exports = __webpack_public_path__ + "img/face-unamused.6412d223.svg";